import React, { useContext } from "react";
import DimensionsIcon from "./dimension-icon";
import PassengersIcon from "./passengers-icon";
import BaggageIcon from "./baggage-icon";
import GettingStartedContext from "../utils/GettingStartedContext";

const DetailSection = () => {
    const { data, langString, getProperty, showToolTip } = useContext(
        GettingStartedContext
    );

    return (
        <div className="gsa__options">
            <div className="grid-container grid-container--gsa">
                <div className="grid-x">
                    <div className="small-12 xlmedium-6 x2large-4 gsa__option">
                        <div className="gsa__option__content">
                            <h4>
                                {langString("YOUR_JET")}
                                {showToolTip("YOUR_JET_TOOLTIP")}
                            </h4>
                            <h3>{getProperty(data.Options.Plane, "Title")}</h3>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: getProperty(
                                        data.Options.Plane,
                                        "HeroIntro"
                                    ),
                                }}
                            />
                            <ul className="specs">
                                <li>
                                    <DimensionsIcon />
                                    <span className="spec-label">
                                        {getProperty(
                                            data.Options.Plane,
                                            "CabinDimensions"
                                        )}
                                    </span>
                                </li>
                                <li>
                                    <PassengersIcon />
                                    <span className="spec-label">
                                        {getProperty(
                                            data.Options.Plane,
                                            "PassengerCapacity"
                                        )}
                                    </span>
                                </li>
                                <li>
                                    <BaggageIcon />
                                    <span className="spec-label">
                                        {getProperty(
                                            data.Options.Plane,
                                            "BaggageCapacity"
                                        )}
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div className="small-12 xlmedium-6 x2large-4 gsa__option">
                        <div className="gsa__option__content">
                            <h4>
                                {langString("YOUR_OWNERSHIP")}
                                {showToolTip("YOUR_OWNERSHIP_TOOLTIP")}
                            </h4>
                            <h3>
                                {getProperty(data.Options.Ownership, "Title")}
                            </h3>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: getProperty(
                                        data.Options.Ownership,
                                        "Description"
                                    ),
                                }}
                            />
                        </div>
                    </div>
                    <div className="small-12 xlmedium-6 x2large-4 gsa__option">
                        <div className="gsa__option__content">
                            <h4>
                                {langString("YOUR_PLAN")}
                                {showToolTip("YOUR_PLAN_TOOLTIP")}
                            </h4>
                            <h3>
                                {getProperty(data.Options.BestPlan, "Title")}{" "}
                            </h3>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: getProperty(
                                        data.Options.BestPlan,
                                        "Description"
                                    ),
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DetailSection;
